import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { StoreStateType } from 'common/store'

type InitialStateType = Res['tenancy'] | null

const initialState = null as InitialStateType

export const tenancySlice = createSlice({
  initialState,
  name: 'tenancy',
  reducers: {
    setTenancy(state, action: PayloadAction<Req['setTenancy']>) {
      state = action.payload
      return state
    },
  },
})

export const tenancyActions = tenancySlice.actions
export const useTenancyActions = () => {
  const dispatch = useDispatch()
  const setTenancy = useCallback(
    (payload: Req['setTenancy']) => {
      return dispatch(tenancyActions.setTenancy(payload))
    },
    [dispatch],
  )
  return { setTenancy }
}

const selectTenancy = (state: StoreStateType) => state.tenancy

export const useTenancy = () => {
  const { setTenancy } = useTenancyActions()
  const tenancy = useSelector(selectTenancy)
  return useMemo(() => ({ setTenancy, tenancy }), [setTenancy, tenancy])
}
